export const UI_GET_MASTER_DATA = 'UI_GET_MASTER_DATA';
export const UI_UPDATE_MASTER_DATA = 'UI_UPDATE_MASTER_DATA';
export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_SET_LOADER_TEXT = 'UI_SET_LOADER_TEXT';
export const UI_UPDATE_FROM_OFFER = 'UI_UPDATE_FROM_OFFER';
export const UI_GET_TOWNS_BY_CP = 'UI_GET_TOWNS_BY_CP';
export const UI_UPDATE_TOWNS_BY_CP_CACHE = 'UI_UPDATE_TOWNS_BY_CP_CACHE';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
